class AuthException extends Error {
  // eslint-disable-next-line
  constructor(message: string) {
    super(message);
  }
}

export default AuthException;
